import { GET_DETAIL_DATA } from "../actions/types";

export default function (state = null, action: any) {
  switch (action.type) {
    case GET_DETAIL_DATA:
      return action.payload;
    default:
      return state;
  }
}
